import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import { intersection as _intersection, last as _last } from 'lodash';
import moment from 'moment';
import Overlay from '../../Overlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var getOverlayKey = function getOverlayKey(top, start, end, layerState) {
  return "".concat(top, "-").concat(start, "-").concat(end, "-").concat(top, "-").concat(JSON.stringify(layerState));
};

var getBackgroundColor = function getBackgroundColor(layer, active) {
  var activeStates = _toConsumableArray(layer.activeStates); // TODO add active state, should be solved somewhere else


  if (active) {
    activeStates.push('active');
  }

  var states = layer.states;

  var activeStatesConfirmed = _intersection(activeStates, states);

  var lastState = _last(activeStatesConfirmed);

  var colors = layer.colors;
  var colorForLastState = colors[lastState];
  return colorForLastState;
};

var LayerRowPeriodItem = function LayerRowPeriodItem(_ref) {
  var active = _ref.active,
      layer = _ref.layer,
      originPeriod = _ref.originPeriod,
      parsedPeriod = _ref.parsedPeriod,
      height = _ref.height,
      onClick = _ref.onClick,
      top = _ref.top,
      activeLevel = _ref.activeLevel,
      dayWidth = _ref.dayWidth,
      getX = _ref.getX,
      mouseX = _ref.mouseX,
      period = _ref.period,
      periodLimit = _ref.periodLimit,
      vertical = _ref.vertical,
      width = _ref.width;
  var timelineParams = {
    activeLevel: activeLevel,
    dayWidth: dayWidth,
    getX: getX,
    mouseX: mouseX,
    period: period,
    periodLimit: periodLimit,
    vertical: vertical,
    width: width
  };
  var overlays = [];

  if (parsedPeriod) {
    var key = getOverlayKey(top, parsedPeriod.start, parsedPeriod.end, layer.layerState);
    var backgroundColor = getBackgroundColor(layer, active);
    overlays.push({
      key: key,
      originPeriod: originPeriod,
      originLayer: layer,
      start: moment("".concat(parsedPeriod.start)),
      end: moment("".concat(parsedPeriod.end)),
      backdroundColor: backgroundColor,
      height: height,
      top: top
    });
    return /*#__PURE__*/_jsx(Overlay, _objectSpread({
      overlays: overlays,
      onClick: onClick
    }, timelineParams), key);
  } else {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
};

LayerRowPeriodItem.propTypes = {
  active: PropTypes.bool,
  activeLevel: PropTypes.string,
  dayWidth: PropTypes.number,
  getX: PropTypes.func,
  height: PropTypes.number,
  layer: PropTypes.shape({
    layerState: PropTypes.any
  }),
  mouseX: PropTypes.number,
  onClick: PropTypes.func,
  originPeriod: PropTypes.object,
  parsedPeriod: PropTypes.shape({
    end: PropTypes.any,
    start: PropTypes.any
  }),
  period: PropTypes.object,
  periodLimit: PropTypes.object,
  top: PropTypes.number,
  vertical: PropTypes.bool,
  width: PropTypes.number
};
export default LayerRowPeriodItem;